import { Directive } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, Validator } from '@angular/forms';

@Directive({
  selector: '[axisNumerics]',
  providers: [
    {
      provide: NG_VALIDATORS,
      useExisting: AxisNumericsValidatorDirective,
      multi: true
    }
  ]
})
export class AxisNumericsValidatorDirective implements Validator {
  validate(control: AbstractControl): { [key: string]: any } {
    const Regex = /^[0-9]*$/;
    return Regex.test(control.value)
      ? null
      : {
          axisNumerics: {
            valid: false
          }
        };
  }
}
